"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upload = exports.registerUpload = exports.createDocumentCode = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _firebaseConfig = _interopRequireWildcard(require("./firebase.config.adesc"));
var _firebaseConfig2 = _interopRequireWildcard(require("./firebase.config.beta"));
var _firebaseConfig3 = _interopRequireWildcard(require("./firebase.config.newton"));
var _common = require("../common");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var upload = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(firebase, path, file, updateProgress, meta) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var storageRef = firebase.storage().ref(path + '/' + file.meta.id + '.' + file.extension);
            var task = storageRef.put(file, meta);
            //Update progress bar
            task.on('state_changed', function progress(snapshot) {
              var percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
              updateProgress(percentage.toFixed(1));
            }, function error(err) {
              reject(err);
            }, function complete() {
              task.snapshot.ref.getDownloadURL().then(function (url) {
                task.snapshot.ref.getMetadata().then(function (metadata) {
                  //('metadata', metadata)
                  resolve({
                    url: url,
                    meta: _objectSpread(_objectSpread({}, metadata), {}, {
                      fullPath: path + '/' + file.meta.id + '.' + file.extension,
                      hash: ''
                    })
                  });
                });
              });
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function upload(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
exports.upload = upload;
var createDocumentCode = function createDocumentCode(hierarchy) {
  //('HIERARCHY', hierarchy)
  var code = hierarchy.map(function (h) {
    return h.code;
  }).join('-');
  return code + '-' + (0, _common.smallUid)();
};
exports.createDocumentCode = createDocumentCode;
var registerUpload = function registerUpload(api) {
  return function (info) {
    // firebase.auth()
    // api.config.headers['firebase-token'] =
    api.post('/document/register/upload', {
      info: info
    });
  };
};
exports.registerUpload = registerUpload;